import { OfferDetailItem } from '@sky-distribution/onboarding-commons-ui/lib/ItemDetailsModal/ItemDetailsModal.types';

import { ToggleSelectHorizontal } from '@sky-distribution/onboarding-commons-ui';
import { TFunction } from 'i18next';
import { translateCoveragePlans } from '../CoverageInfoModal.utils';
import { SelectCoveragePlanHeaderWrapper } from './SelectCoveragePlanHeader.styled';

export interface SelectCoveragePlanHeaderProps {
  coveragePlans: OfferDetailItem[];
  selectedPlanIndex: number;
  onChange: (value: number) => void;
  t: TFunction;
}

export const SelectCoveragePlanHeader = ({
  coveragePlans,
  selectedPlanIndex,
  onChange,
  t,
}: SelectCoveragePlanHeaderProps): JSX.Element => {
  const options = translateCoveragePlans(coveragePlans, t)
    .map(({ additionalDescription }, index) => ({
      title: additionalDescription,
      value: index,
    }));

  return (
    <SelectCoveragePlanHeaderWrapper>
      {options && (
        <ToggleSelectHorizontal
          options={options}
          value={selectedPlanIndex}
          onChange={(newSelectedOption) => onChange(newSelectedOption as number)}
        />
      )}
    </SelectCoveragePlanHeaderWrapper>
  );
};
